import { Injectable } from "@angular/core";
import { ArbetsorderViol3SynchronizationData } from "~app/common/events/saga/ArbetsorderViol3SynchronizationData";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IOperationBase } from "~app/features/planera/model/IOperationBase";
import { ArbetsorderOperationDeletedEvent } from "../events/ArbetsorderOperationDeletedEvent";
import { ArbetsorderOperationUpdatedEvent } from "../events/ArbetsorderOperationUpdatedEvent";
import { DestineringsalternativMergeCompletedEventMessage } from "../events/DestineringsalternativMergeCompletedEventMessage";

@Injectable({
    providedIn: "root"
})
// Här samlas metoder som används för att sätta egenskaper på en arbetsorder som sker via ett event
// Det finns minst två ställen där dessa saker sätts vilket är på en AO i sökresultatslistan samt AO-detaljsidan
export class ArbetsorderInmemoryPropertyApplierService {

    handleOperationUpdatedEvent(arbetsorder: IArbetsorderDetail, ev: ArbetsorderOperationUpdatedEvent): void {
        if (arbetsorder?.id === ev.arbetsorderId) {
            this.updateOperationDates(ev, arbetsorder.operationer);
            arbetsorder.maskinikon = !!ev.maskinlagId;
            arbetsorder.maskinlagId = ev.maskinlagId;
            arbetsorder.rowVersion = ev.arbetsorderRowVersion;
            arbetsorder.maskinlagId = ev.maskinlagId;
            arbetsorder.entreprenorId = ev.entreprenorId;
        }
    }

    handleOperationDeletedEvent(arbetsorder: IArbetsorderDetail, ev: ArbetsorderOperationDeletedEvent): void {
        if (arbetsorder?.id === ev.arbetsorderId) {
            arbetsorder.operationer.splice(arbetsorder.operationer.findIndex(item => item.operationstyp === ev.typ), 1);
            arbetsorder.rowVersion = ev.arbetsorderRowVersion;
        }
    }

    handleArbetsorderViol3SynchronizationData(arbetsorder: IArbetsorderDetail, ev: ArbetsorderViol3SynchronizationData): void {
        if (arbetsorder && arbetsorder?.id === ev.arbetsorderId) {
            arbetsorder.skickadTillViol3 = ObjectUtils.hasValue(ev.skickadTillViol3);
        }
    }

    handleDestineringsalternativMergeCompletedEvent(arbetsorder: IArbetsorderDetail, ev: DestineringsalternativMergeCompletedEventMessage): void {
        if (arbetsorder && arbetsorder?.id === ev.arbetsorderId) {
            arbetsorder.destinerad = ev.destinerad;
        }
    }

    private updateOperationDates(ev: ArbetsorderOperationUpdatedEvent, operationer: IOperationBase[]): void {
        const operation = operationer.find(op => op.operationstyp === ev.typ);
        if (!operation) {
            operationer.push({
                operationstyp: ev.typ,
                slutdatum: ev.slutdatum,
                startdatum: ev.startdatum,
                id: ev.operationId
            });
        } else {
            operation.slutdatum = ev.slutdatum;
            operation.startdatum = ev.startdatum;
        }
    }

}
